import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";

import infertility from "images/infertility.png";
import maternity from "images/maternity.png";
import gynecology from "images/gynecology.png";
import seema from "images/seema-welcome.jpeg";
import sthetoscope from "images/sthetoscope.png";
import teenager from "images/teenager.png";

const HighlightedText = styled.span`
  background: linear-gradient(135deg, #E0F5F3, #B3E8E2);
  color: #1B6158;
  padding: 0 0.5rem;
  border-radius: 4px;
  display: inline-block;
  transform: skewX(-6deg);
  font-style: italic;
`;

const Subheading = styled.span`
  font-family: 'Nunito', sans-serif;
  font-size: 0.8rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #2A9D8F;
`;

const Description = tw.span`inline-block mt-4`;

const imageCss = tw`rounded-2xl`;

export default () => {
  return (
    <AnimationRevealPage>
      <Hero
        heading={
          <>
            Namaste — <HighlightedText>Ludhiana's Trusted Gynaecology Clinic</HighlightedText>
          </>
        }
        description="Welcome to Kaushal Clinic — your trusted partner in women's health since 2008. Dr. Seema Kaushal and her dedicated team provide expert, compassionate care for gynaecology, infertility, family planning, and adolescent health in Ludhiana."
        imageSrc={seema}
      />

      <MainFeature
        subheading={<Subheading>Established Since 2008</Subheading>}
        heading={
          <>
            Over 15 Years of{" "}
            <HighlightedText>Caring for Women's Health</HighlightedText>
          </>
        }
        description={
          <Description>
            At Kaushal Clinic, we've spent over 15 years building a reputation as Ludhiana's most trusted gynaecology practice. Led by Dr. Seema Kaushal, our clinic provides a warm, private, and professional environment where every patient is treated with dignity, compassion, and expert medical care.
            <br /><br />
            From routine check-ups and prenatal guidance to advanced infertility consultations and adolescent health support — we are with you at every stage of your journey. Your health, privacy, and comfort are our highest priorities.
          </Description>
        }
        primaryButtonText="Book via WhatsApp"
        primaryButtonUrl="https://wa.me/+919815662600"
        buttonRounded={false}
        textOnLeft={false}
        imageSrc={sthetoscope}
        imageCss={imageCss}
        imageShadow={true}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />

      <Features
        subheading="What We Offer"
        heading={
          <>
            Our <HighlightedText>Specialist Services</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: gynecology,
            title: "Gynaec Consultation",
            description: "Expert gynaecological consultations covering routine check-ups, menstrual health, hormonal concerns, and all aspects of women's wellness — tailored to your unique needs.",
          },
          {
            imageSrc: infertility,
            title: "Infertility Consultation",
            description: "Compassionate, evidence-based guidance for couples facing fertility challenges. Personalised evaluation and treatment planning to help you on your path to parenthood.",
          },
          {
            imageSrc: maternity,
            title: "Family Planning",
            description: "Comprehensive family planning support — from contraception counselling to preconception health planning — empowering you to make informed, confident reproductive choices.",
          },
          {
            imageSrc: teenager,
            title: "Adolescent Health",
            description: "Safe, non-judgemental health education and care for teenage girls navigating puberty, menstrual health, and the physical and emotional changes of adolescence.",
          },
        ]}
        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
        id="services"
      />

      <Footer id="footer" />
    </AnimationRevealPage>
  );
};
